module.exports = __webpack_public_path__ + "static/media/man looking after casks of whisky.f542caf5.jpg";